import React from 'react'
import { Box, Typography, BoxProps } from '@mui/material'
import {
  DateCalendar,
  PickersDay,
  PickersDayProps,
  StaticDatePickerProps
} from '@mui/x-date-pickers-pro'
import moment, { Moment } from 'moment'

interface Props extends Partial<Omit<BoxProps, 'onChange'>> {
  error?: string
  onChange: (selectedDates: Moment[]) => void
  selectedDates: Moment[]
  calendarProps?: Partial<StaticDatePickerProps<Moment>>
}

// const StyledPickersDay = styled(PickersDay)(() => ({
//   '&.MuiButtonBase-root:not(.Mui-selected)': {
//     border: 'none'
//   },
//   '&.pickerSelectedDay:hover': {
//     willChange: 'background-color',
//     backgroundColor: '#1565c0'
//   },
//   '&.pickerSelectedDay': {
//     color: '#fff !important',
//     backgroundColor: '#1976d2 !important',
//     fontWeight: '500 !important',
//     transition:
//       'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important'
//   },
//   '&.Mui-selected:hover, &.Mui-selected:focus': {
//     willChange: 'none',
//     backgroundColor: 'rgba(0, 0, 0, 0.04)'
//   },
//   '&.Mui-selected': {
//     color: 'rgba(0, 0, 0, 0.87)',
//     backgroundColor: '#fff',
//     fontWeight: '400',
//     transition: 'none'
//   },
//   '&.Avail-disabled': {
//     userSelect: 'none',
//     pointerEvents: 'none',
//     color: '#c6c6c6'
//   }
// }))

const DaysCalendarPicker = React.forwardRef(
  (
    { error, onChange, selectedDates, calendarProps, ...boxProps }: Props,
    ref
  ) => {
    const handleSelectDate = (selectedDate: Moment) => {
      const dateAlreadyExist = selectedDates.some((date) =>
        moment(date).isSame(selectedDate, 'day')
      )
      let newSelectedDates
      if (dateAlreadyExist) {
        newSelectedDates = selectedDates.filter(
          (date) => !moment(date).isSame(selectedDate, 'day')
        )
        console.log(newSelectedDates)
        return onChange(newSelectedDates)
      }
      newSelectedDates = [...selectedDates, selectedDate]
      console.log(newSelectedDates)
      return onChange(newSelectedDates)
    }

    return (
      <Box
        sx={{
          position: 'relative'
        }}
        ref={ref}
        {...boxProps}
      >
        {error && (
          <Typography
            sx={{
              fontSize: '14',
              color: 'red'
            }}
          >
            {error}
          </Typography>
        )}
        <DateCalendar
          minDate={moment()}
          slots={{
            day: (
              props: PickersDayProps<Moment> & { selectedDay?: Moment | null }
            ) => {
              const { day, selectedDay, ...other } = props

              const isSelected = selectedDates.some((day) =>
                day.isSame(props.day, 'day')
              )

              return (
                <PickersDay
                  {...(other as any)}
                  day={day as any}
                  selected={isSelected}
                  // className={`${isSelected ? 'pickerSelectedDay' : ''}`}
                />
              )
            }
          }}
          onChange={(date: Moment | null) => {
            if (date != null) {
              handleSelectDate(date)
            }
          }}
        />
      </Box>
    )
  }
)

DaysCalendarPicker.displayName = 'DaysCalendarPicker'

export default DaysCalendarPicker
